import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let hasRegisteredPlugin = false;
var heroFadeStartProgress = 0.58;
var heroFadeEndProgress = 0.84;

function registerScrollTrigger() {
  if (hasRegisteredPlugin) {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  hasRegisteredPlugin = true;
}

function getHeaderHeight() {
  var header = document.querySelector('.site-header');
  return header ? Math.round(header.getBoundingClientRect().height) : 0;
}

function getHeroPinDistance(heroElement, gridElement, ctaElement) {
  if (!heroElement || !gridElement || !ctaElement) {
    return 0;
  }

  var gapAfterCta = 24;
  var ctaRect = ctaElement.getBoundingClientRect();
  var gridRect = gridElement.getBoundingClientRect();
  var ctaBottom = ctaRect.bottom + window.pageYOffset;
  var gridTop = gridRect.top + window.pageYOffset;

  return Math.max(0, Math.round(gridTop - ctaBottom - gapAfterCta));
}

export function initializeVerticalGalleryHeroPin() {
  if (typeof window === 'undefined') {
    return function noop() {};
  }

  registerScrollTrigger();

  var sectionElement = document.querySelector('.home-section--vertical-gallery');

  if (!sectionElement) {
    return function noop() {};
  }

  var heroElement = sectionElement.querySelector('.vertical-gallery__hero');
  var gridElement = sectionElement.querySelector('.vertical-gallery__grid');
  var ctaElement = sectionElement.querySelector('.vertical-gallery__intro-cta');

  if (!heroElement || !gridElement || !ctaElement) {
    return function noop() {};
  }

  var mediaMatcher = gsap.matchMedia();

  mediaMatcher.add({
    reduceMotion: '(prefers-reduced-motion: reduce)',
    desktop: '(min-width: 1025px)',
    tablet: '(min-width: 768px) and (max-width: 1024px)',
    mobile: '(max-width: 767px)',
  }, function setupVerticalGalleryHeroPin(context) {
    var conditions = context.conditions;

    if (conditions.reduceMotion || conditions.mobile) {
      sectionElement.classList.remove('home-section--vertical-gallery-pinned-active');
      gsap.set(heroElement, { clearProps: 'opacity' });
      return undefined;
    }

    var pinDistance = getHeroPinDistance(heroElement, gridElement, ctaElement);

    if (pinDistance <= 0) {
      sectionElement.classList.remove('home-section--vertical-gallery-pinned-active');
      gsap.set(heroElement, { clearProps: 'opacity' });
      return undefined;
    }

    var timeline = gsap.timeline({
      defaults: {
        ease: 'none',
      },
      scrollTrigger: {
        trigger: sectionElement,
        start: function start() {
          return 'top top+=' + getHeaderHeight();
        },
        end: function end() {
          return '+=' + getHeroPinDistance(heroElement, gridElement, ctaElement);
        },
        pin: heroElement,
        pinSpacing: false,
        scrub: 0.35,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onToggle: function onToggle(self) {
          sectionElement.classList.toggle('home-section--vertical-gallery-pinned-active', self.isActive);
        },
      },
    });

    timeline.fromTo(
      heroElement,
      { opacity: 1 },
      { opacity: 0, duration: heroFadeEndProgress - heroFadeStartProgress },
      heroFadeStartProgress
    );

    return function cleanupVerticalGalleryHeroPin() {
      timeline.kill();
      sectionElement.classList.remove('home-section--vertical-gallery-pinned-active');
      gsap.set(heroElement, { clearProps: 'opacity' });
    };
  });

  return function cleanupAll() {
    mediaMatcher.revert();
    sectionElement.classList.remove('home-section--vertical-gallery-pinned-active');
    gsap.set(heroElement, { clearProps: 'opacity' });
    ScrollTrigger.refresh();
  };
}
